var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"12","height":"6","viewBox":"0 0 12 6","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0 0L12 0L6 6Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }